import { Box, styled } from "@mui/material";
import theme from "../../../../theme";

export const SendEmailComponentStyle = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

export const SendEmailContainer = styled(Box)`
  margin: 8px;
  width: 100%;
  min-height: 20px;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 10px;
`;

export const EmailTextFieldWrapper = styled(Box)`
  margin-top: 15px;
  align-items: center;
  display: flex;
`;

export const DisableEmailText = styled(Box)`
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: ${theme.palette.secondary.main};
`;
